import { Accordion, Breakpoints, useBreakpoint } from '@nextgen-web-framework/all';
import { NavigationSource } from './types/propsTypes';
import type { NavigationProps, VerticalTabNavigationProps } from './types/propsTypes';
import VerticalTabNavigationItem from './verticalTabNavigationItem/VerticalTabNavigationItem';
import styles from './VerticalTabNavigation.module.scss';
const VerticalTabNavigation = (props: VerticalTabNavigationProps) => {
  const viewPortType = useBreakpoint() as Breakpoints;
  const isMobileView = [Breakpoints.XS, Breakpoints.SM, Breakpoints.MD].includes(viewPortType);

  const onToggle = (e: React.KeyboardEvent | React.MouseEvent, status: boolean, url: string) => {
    props.goToRoute && props.goToRoute(url);
  };

  const renderAccordion = (data: NavigationProps[], activeRoute?: string) => (
    <>
      {data?.map((navigationItem) => (
        <Accordion
          data-testid="vertical-tab-accordion-test-id"
          key={navigationItem.label}
          id={navigationItem.label}
          onToggleCallback={(e, status) => onToggle(e, status, navigationItem.url)}
          isOpen={navigationItem.url === activeRoute}
          title={navigationItem.label}
        >
          <>
            {navigationItem.url === activeRoute && (
              <div className={styles['vertical-tab-mobile-content']}>{props.content}</div>
            )}
          </>
        </Accordion>
      ))}
    </>
  );

  const renderNavigationItem = (data: NavigationProps[], activeRoute?: string) => (
    <>
      {data?.map((navigationItem) => (
        <div key={navigationItem.label}>
          <VerticalTabNavigationItem
            label={navigationItem.label}
            url={navigationItem.url}
            iconName={navigationItem.iconName}
            activeRoute={activeRoute}
            source={props.source}
            target={navigationItem?.target}
          />
        </div>
      ))}
    </>
  );

  return (
    <div className={styles['vertical-tab-container']}>
      {!props.disableNavigation && (
        <div className={`${styles[`vertical-tab-site-tabs-${props.source}`]} ${props.customClass}`}>
          {isMobileView
            ? renderAccordion(props.data, props.activeRoute)
            : renderNavigationItem(props.data, props.activeRoute)}
        </div>
      )}
      {(props.disableNavigation || !isMobileView) && (
        <div
          className={`${isMobileView ? styles['vertical-tab-full-content'] : styles['vertical-tab-content']}`}
          data-testid="vertical-tab-content-test-id"
        >
          {props.content}
        </div>
      )}
    </div>
  );
};

export default VerticalTabNavigation;
export { NavigationSource };
export type { VerticalTabNavigationProps, NavigationProps };
